// extracted by mini-css-extract-plugin
module.exports = {"root":"quoted-tweet-body_root__szSfI"};